import { modalDarkColors } from './dark'
import { modalDarkBlueColors } from './darkBlue'

export const modalColors = {
  dark: modalDarkColors,
  darkblue: modalDarkBlueColors,
} as const

export enum ModalColorTheme {
  Dark = 'dark',
  Darkblue = 'darkblue',
}
